import {HeaderTheme} from './change-header-bg';

export const initHeaderThemeChange = () => {
  const headerTheme = new HeaderTheme();
  headerTheme.init();
};
